// ===== Products Slider ====== //

$(".product_slider_cstm_ud .sliderr-wrapper").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: true,
  prevArrow:
    '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"></path></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1601,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
      },
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2.3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1.5,
        arrows: false,
        dots: true,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1.1,
        arrows: false,
        dots: true,
      },
    },
  ],
});

//  ==== Take Health Main Section ====//

var $slider = $(".take_health_main .main_slider_item");
$slider.on("init afterChange", function (event, slick, currentSlide) {
  var totalSlides = slick.slideCount;
  var slidesToShow = slick.options.slidesToShow;
  var nextArrow = $(slick.$nextArrow);
  var prevArrow = $(slick.$prevArrow);
  if (currentSlide >= totalSlides - slidesToShow) {
    nextArrow.hide();
  } else {
    nextArrow.show();
  }
  if (currentSlide <= 0) {
    prevArrow.hide();
  } else {
    prevArrow.show();
  }
});

$slider.slick({
  infinite: false,
  slidesToShow: 3.5,
  slidesToScroll: 1,
  dots: false,
  arrows: true,
  prevArrow:
    '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"></path></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.2,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
      },
    },
  ],
});

//  ====== Testimonials Slider ========//
$(".testimonials-main-slider-section .slider_testimonials_wrp").slick({
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 10000,
  cssEase: "linear",
  arrows: false,
  responsive: [
    {
      breakpoint: 1401,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
      },
    },
  ],
});

//  ====== blog section slider  ===== //
$(".blog_slider_section_main .slider_wrapper_blogs").slick({
  dots: false,
  slidesToShow: 4.5,
  slidesToScroll: 1,
  speed: 1000,
  infinite: false,
  swipeToSlide: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 1601,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2.1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1.1,
        slidesToScroll: 1,
      },
    },
  ],
});

// ====== Video With Text Section =======//
$(".video_part_main").on("click", function () {
  $(".video-overlay-homepage").hide();
  $(".video_part_inner_main").show();

  var video = $(".video_part_inner_main video")[0];
  video.play();
});

//  ====== Custom Accordion Section ======= //

$(".accordion-content").hide();
$(".accordion button").click(function () {
  var ariaExpanded = $(this).attr("aria-expanded");
  $(".accordion button").attr("aria-expanded", "false");
  $(".accordion .accordion-content").slideUp();
  $(".accordion .icon i").removeClass("fa-minus").addClass("fa-plus");
  if (ariaExpanded === "false") {
    $(this).attr("aria-expanded", "true");
    $(this).next(".accordion-content").slideDown();
    $(this).find(".icon i").removeClass("fa-plus").addClass("fa-minus");
  }
});

// ---- Megamenu --- Hide show desktp --- //
$(document).on(
  "click",
  "li.menu-lv-item.shownav a.menu-lv-1__action",
  function (event) {
    event.stopPropagation();

    $(".cstm_megaMenu_uD").not($(this).next(".cstm_megaMenu_uD")).hide();

    $("li.menu-lv-item.shownav a.menu-lv-1__action")
      .not(this)
      .removeClass("active-link");
    $(this).toggleClass("active-link");

    $(this).next(".cstm_megaMenu_uD").toggle();

    if ($(".cstm_megaMenu_uD:visible").length > 0) {
      $(".megamenu-overlay").show();
      $("body").addClass("megamenu-open");
    } else {
      $(".megamenu-overlay").hide();
      $("body").removeClass("megamenu-open");
    }
  }
);

$(document).on("click", ".cstm_megaMenu_uD", function (event) {
  event.stopPropagation();
});

$("body").on("click", function (e) {
  if (
    !$(e.target).closest("li.menu-lv-item.shownav").length &&
    !$(e.target).closest(".cstm_megaMenu_uD").length
  ) {
    $("body").removeClass("megamenu-open");
    $(".cstm_megaMenu_uD").hide();
    $(".megamenu-overlay").hide();
    $("li.menu-lv-item.shownav a.menu-lv-1__action").removeClass("active-link");
  }
});

// ===== Mobille-megamenu ==== ///
$(".item__mobile--hamburger a.mobileMenu-toggle").attr(
  "href",
  "javascript:void(0)"
);

$(document).on(
  "click",
  ".menu-lv-item.shownav_mob .list-menu__item",
  function (event) {
    event.preventDefault();
    $("body").addClass("mobile_megamenu_sidebar_open");
    $(this).next(".cstm_megaMenu_mobile").addClass("open_active_sidebar");
    // console.log("add");
  }
);

$(document).on(
  "click",
  ".cstm_megaMenu_mobile .back_btn_main",
  function (event) {
    event.preventDefault();
    $("body").removeClass("mobile_megamenu_sidebar_open");
    $(this).closest(".cstm_megaMenu_mobile").removeClass("open_active_sidebar");
    // console.log("remove");
  }
);

// == Giveaway Main JS Slider === //
$(".main_form_cstm_giveaway .slick_slide_images_vdos").slick({
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  speed: 500,
  swipeToSlide: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  adaptiveHeight: true,
  // centerMode: true,
  // centerPadding: '20px',
  prevArrow:
    '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"></path></svg></button>',
  nextArrow:
    '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1601,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 481,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".main_form_cstm_giveaway .slick_slide_images_vdos").on(
  "beforeChange",
  function (event, slick, currentSlide, nextSlide) {
    // Pause all videos
    $(".main_form_cstm_giveaway .slick_slide_images_vdos video").each(
      function () {
        this.pause();
      }
    );
  }
);

$(".main_form_cstm_giveaway .slick_slide_images_vdos").on(
  "afterChange",
  function (event, slick, currentSlide) {
    // Play video in the active slide
    var currentSlideElement = $(".slick-current video");
    if (currentSlideElement.length) {
      currentSlideElement[0].play();
    }
  }
);

$(".main_form_cstm_giveaway .slick_slide_images_vdos").hover(
  function () {
    $(this).slick("slickPause");
  },
  function () {
    $(this).slick("slickPlay");
  }
);



// ====== PDP Call back request popup =========//
$(".opencallback_form").on("click", function () {
  $(".call_back_pdp_popup").addClass("active");
  $('body').addClass('call-back-popup-open');
});
$(".close_button").on("click", function () {
  $(".call_back_pdp_popup").removeClass("active");
  $('body').removeClass('call-back-popup-open');
});
$(document).on("click", function (event) {
  if (!$(event.target).closest(".call_back_pdp_popup, .opencallback_form").length) {
    $(".call_back_pdp_popup").removeClass("active");
    $('body').removeClass('call-back-popup-open');
  }
});

// ====== PDP accordions block ========== //
$(".accordion_header_pdp").click(function () {
  $(".accordion_content_pdp").not($(this).next()).slideUp();
  $(".accordion_header_pdp").not($(this)).removeClass("active");
  $(".toggle-icon svg").not($(this).find("svg")).css({
    transform: "rotate(0deg)",
    transition: "0.3s ease",
  });
  $(this).toggleClass("active");
  $(this).next(".accordion_content_pdp").slideToggle();
  const icon = $(this).find(".toggle-icon svg");
  if ($(this).hasClass("active")) {
    icon.css({
      transform: "rotate(90deg)",
      transition: "0.3s ease",
    });
  } else {
    icon.css({
      transform: "rotate(0deg)",
      transition: "0.3s ease",
    });
  }
});


$(".product-form-radio-list-add-a-bath .product-form-radio-item label span.text").on("click", function () {

 var varText = $(this).text();
  if(varText == 'Tub'){
    window.location.href='https://primalice.com.au/products/ice-bath-with-chiller';
  }
  else if(varText == 'Barrel'){
    window.location.href='https://primalice.com.au/products/ice-barrel-with-chiller';
   
  }


  
});

